module.exports = __webpack_public_path__ + "static/media/3DPPA3.8d9b83e8.jpg";